/**
 * Used for tracking salesmails views. These are url parameter values that can be appended to 
 * the LONG / FULL url and NOT short url due to the way the forwarder works.
 * This can be used with the merge tags function on the preview component, or also set manually
 * for tracking 1:1, such as via CRM forwarding
 */
export type SalesMailTrackingParams = {
    first_name?: string;
    last_name?: string;
    email?: string;
}

export type SalesMailCrm = {
  id: number;
  name: string;
  merge_tags?: SalesMailTrackingParams
};

export const ENQUIRE_CRM = 1;
export const ZOHO_CRM = 2;
export const SHERPA_CRM = 3;
export const WELCOME_HOME_CRM = 4;
export const KNOCK_CRM = 5;
export const YARDI_CRM = 6;
export const ENTRATA_CRM = 7;
export const SALESFORCE_CRM = 8;
export const HUBSPOT_CRM = 9;

export const SalesMailCrms: SalesMailCrm[] = [
    {
        id: ENQUIRE_CRM,
        name: 'Enquire',        
    },
    {
        id: ZOHO_CRM,
        name: 'Zoho',
        merge_tags: {
            first_name: '$[UD:FIRST_NAME||]$',
            last_name: '$[UD:LAST_NAME||]$',
            email: '$[UD:CONTACT_EMAIL||]$'
        }
    },
    {
        id: SHERPA_CRM,
        name: 'Sherpa'
    }, 
    {
        id: WELCOME_HOME_CRM,
        name: 'Welcome Home', 
        merge_tags: {
            first_name: '{{prospect_name}}',      // For corey's testing
        }           
    },
    {
        id: KNOCK_CRM,
        name: 'Knock'
    },
    {
        id: YARDI_CRM,
        name: 'Yardi',        
    }, 
    {
        id: ENTRATA_CRM,
        name: 'Entrata'
    },
    {
        id: SALESFORCE_CRM,
        name: 'Salesforce',        
    },
    {
        id: HUBSPOT_CRM,
        name: 'Hubspot',
        merge_tags: {
            first_name: '{{ contact.firstname }}',
            last_name: '{{ contact.lastname }}',
            email: '{{ contact.email }}'
        }
    },
]